import React from "react";
import "./_CalculatePriceButton.scss";
import { ReactComponent as Checkmark } from "../../assets/svg/checkmark.svg";
import { ReactComponent as CheckmarkChecked } from "../../assets/svg/checkmark-checked.svg";

export const CalculatePriceButton = ({ text, calculatePrice, onPress }) => {
  /**
   * Text is in NEGATIVE form -> checkmark is checked when calculateNecklacePrice is false
   */
  return (
    <button className="calculate-price-button" onClick={onPress}>
      {calculatePrice ? <Checkmark /> : <CheckmarkChecked />}
      {text}
    </button>
  );
};
